// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

// Opened with the ContractController scope as parent, so the template can use productInfo, priceList and
// getPriceListItem, and the actions delegate to the contract's existing component subscription dialogs.
var ComponentSubscriptionDetailsController = function ($scope, $modalInstance, componentSubscription, canModify, ComponentSubscription, gettextCatalog, gettext) {
    $scope.componentSubscription = componentSubscription;
    $scope.canModify = canModify;
    // 'description' or 'customFields' while that section is edited inline
    $scope.editing = null;
    $scope.edited = null;

    var runAction = function (action) {
        $modalInstance.close();
        action(componentSubscription);
    };

    $scope.hasEditableCustomFields = function () {
        return ($scope.componentSubscriptionCustomFieldSettings || []).some(function (field) {
            return field.EditInUI === 'ReadWrite';
        });
    };

    $scope.startEdit = function (section) {
        // list items come from ComponentSubscriptionByContract, which has no update action, so load the one to save
        ComponentSubscription.get({ componentSubscriptionId: componentSubscription.Id }, function (data) {
            $scope.edited = data;
            $scope.editing = section;
        });
    };

    $scope.cancelEdit = function () {
        $scope.editing = null;
        $scope.edited = null;
    };

    $scope.saveEdit = function () {
        $scope.edited.$update({ componentSubscriptionId: componentSubscription.Id }, function (updated) {
            componentSubscription.Memo = updated.Memo;
            componentSubscription.CustomFields = updated.CustomFields;
            $scope.cancelEdit();
            $scope.notify("success", gettextCatalog.getString(gettext("Component subscription updated successfully")));
        });
    };

    $scope.adjustQuantity = function () {
        runAction($scope.replaceSubscription);
    };

    $scope.cancelSubscription = function () {
        runAction($scope.endSubscription);
    };

    $scope.close = function () {
        $modalInstance.dismiss('cancel');
    };
};

ComponentSubscriptionDetailsController.$inject = ['$scope', '$uibModalInstance', 'componentSubscription', 'canModify', 'ComponentSubscription', 'gettextCatalog', 'gettext'];
